/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { TextInput, TouchableOpacity, View } from "react-native";
import { Text, styles } from "UpduoLibrary";
import { skalePrimaryBlue, skaleWebTextLightGray } from "config/UpduoColors";
import * as UpduoAnalytics from "config/UpduoAnalytics";

interface LoginFormProps {
  email?: string;
  password?: string;
  startObject?: any;
  onChangeTextEmail?: (text: string) => void;
  onKeyPressEmail?: (e: any) => void;
  onChangeTextPassword?: (text: string) => void;
  onKeyPressPassword?: (e: any) => void;
}

export default function LoginForm({
  email,
  password,
  startObject,
  onChangeTextEmail,
  onKeyPressEmail,
  onChangeTextPassword,
  onKeyPressPassword,
}: LoginFormProps) {
  const variableTextInputStyle =
    startObject.orgJoinRule === "E"
      ? [styles.textInput, { color: skaleWebTextLightGray }]
      : styles.textInput;
  return (
    <View>
      <Text isHeading={true} style={styles.routeHeading}>
        {"Log In"}
      </Text>
      <Text style={styles.textInputHeader}>{"Email Address"}</Text>
      <TextInput
        value={email}
        onChangeText={onChangeTextEmail}
        autoCapitalize={"none"}
        autoCorrect={false}
        style={variableTextInputStyle}
        autoFocus={true}
        onKeyPress={onKeyPressEmail}
        editable={!(startObject.orgJoinRule === "E" && email)}
      />
      <Text style={styles.textInputHeader}>{"Password"}</Text>
      <TextInput
        value={password}
        onChangeText={onChangeTextPassword}
        secureTextEntry={true}
        autoCapitalize={"none"}
        style={styles.textInput}
        onKeyPress={onKeyPressPassword}
      />
      <TouchableOpacity
        style={{ marginTop: 20 }}
        onPress={() => {
          UpduoAnalytics.logEvent("user-home-password-reset", {
            email,
          });
          window.open(
            `${process.env.REACT_APP_SERVER_URL}/accounts/password/reset/`,
            "_blank"
          );
        }}
      >
        <Text style={{ color: skalePrimaryBlue, fontSize: 12 }}>
          {"Forgot Password?"}
        </Text>
      </TouchableOpacity>
    </View>
  );
}
